import { selectEmvPaymentModuleState } from '@ticketmaster/tm1pos-web-shared/payment/emvPaymentModule-selectors';
import { type EmvTransaction, TransactionStatus } from '@ticketmaster/tm1pos-web-shared/payment/emvPaymentModule-types';
import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { START_EMV_TRANSACTION } from '../components/form/actions-constants';

type EmvTransactionResult = { status: 'SUCCESS'; emvTransaction: EmvTransaction } | { status: 'ABORTED' };

export const useEmvPaymentDevice = () => {
  const promiseResolverRef = useRef<(result: EmvTransactionResult) => void>();
  const { transaction: emvTransaction } = useSelector(selectEmvPaymentModuleState);
  const dispatch = useDispatch();

  const completeEmvTransaction = (result: EmvTransactionResult) => {
    if (promiseResolverRef.current) {
      promiseResolverRef.current(result);
      promiseResolverRef.current = undefined;
    }
  };

  useEffect(() => {
    const status = emvTransaction.status;
    switch (status) {
      case TransactionStatus.FAILURE:
      case TransactionStatus.CANCELLED: {
        completeEmvTransaction({ status: 'ABORTED' });
        break;
      }
      case TransactionStatus.SUCCESS: {
        completeEmvTransaction({ status: 'SUCCESS', emvTransaction });
        break;
      }
      default: {
        break;
      }
    }
  }, [emvTransaction]);

  const waitForEmvTransactionCompletion = () =>
    new Promise<EmvTransactionResult>((resolve) => {
      promiseResolverRef.current = resolve;
    });

  const startEmvTransaction = () => {
    dispatch({ type: START_EMV_TRANSACTION });
  };

  return {
    waitForEmvTransactionCompletion,
    startEmvTransaction,
  };
};
